<template>
  <shared-product-provide :product="product" :fromModule="fromModule" :toModule="toModule">

    <form-group v-if="this.useAnatel" label="Identificador de certificação da Anatel" :columns="3" :required="false">
      <input class="form-input" type="text" v-model="identifierAnatel">
    </form-group>

    <form-group :label="$t('warranty.label')" :error="getError('warranty', product.productId)" :required="true">
      <input type="number" class="form-input" v-model="product.warrantyTime">
    </form-group>

    <div class="l-col-12@md" v-if="this.attributes.length">
      <div class="divider"><span>Atributos</span></div>
    </div>

    <form-group :label="$t(attribute.name + '.label')" v-if="attribute.name !== 'weight' && attribute.name !== 'color' && attribute.name !== 'quantity'" v-for="attribute in this.attributes">
      <input :type="attribute.type" class="form-input" v-if="attribute.type !== 'decimal' && attribute.type !== 'select'" v-model="product.attributes[attribute.name]">
      <input type="number" class="form-input" v-if="attribute.type === 'decimal'" v-model="product.attributes[attribute.name]" step=".1">
      <select class="form-select" v-if="attribute.type === 'select'" v-model="product.attributes[attribute.name]">
        <option value="">Selecione</option>
          <option v-for="value in attribute.values" v-if="attribute.values !== undefined" :key="value.id" :value="value.name">
            {{ value.name }}
          </option>
      </select>
    </form-group>

    <div class="l-col-12@md">
      <div class="divider"><span>Ficha Técnica</span></div>
    </div>

    <div class="l-col-12@md no-padding" v-for="technicalAttribute in this.technicalAttributes">
      <form-group label="Nome do atributo">
        <input type="text" class="col form-input" @change="isFormValid" v-model="technicalAttribute['name']">
      </form-group>
      <form-group label="Valor">
        <input type="text" class="col form-input" @change="isFormValid" v-model="technicalAttribute['value']">
      </form-group>
      <button class="btn" @click="removeTechnicalSpec(technicalAttribute['id'])">Remover</button>
    </div>

    <div class="l-col-12@md no-padding">
      <button style="margin-left: 8px;" class="btn btn--smart btn--sm btn--info l-level__right" :disabled="!this.isFormValid()" @click="addTechnicalSpec">Adicionar Atributo</button>
    </div>

  </shared-product-provide>
</template>

<script>
  import { mapGetters } from 'vuex'
  import SharedProductProvide from '@/components/marketplace/shared/provide/Product'
  import FormGroup from '@/components/template/FormGroup'
  import api from '@/api'

  export default {
    provide: {
      moduleDI: {
        type: 'marketplace',
        identifier: 'integracommerce'
      },
      maxDescriptionLengthDI: 32767,
      allowDescriptionHtml: true
    },
    data: () => ({
      categories: [],
      attributes: [],
      technicalAttributes: [],
      isAddDisabled: false,
      identifierAnatel: null,
      anatelCategories: [
        'Celulares e Smartphones',
        'Áudio',
        'Informática',
        'TV e Vídeo',
        'Tablets-iPads-EReader',
        'Casa Inteligente',
        'Automotivo(aparelhos eletrônicos)',
        'Telefonia Fixa',
        'Casa e Construção(aparelhos eletrônicos)',
        'Games',
        'Bebê(aparelhos eletrônicos)',
        'Saúde e Cuidados Pessoais (aparelhos eletrônicos)'
      ],
      useAnatel: false
    }),
    props: {
      product: {
        type: Object,
        required: true
      },
      fromModule: {
        type: Object,
        required: true
      },
      toModule: {
        type: Object,
        required: true
      }
    },
    mounted () {
      this.product.warrantyTime = this.formatWarrantyToMonth(this.product.warrantyTime)
      this.$parent.loadingProducts(false)
      this.setIsAnatel()
      this.fetchAttributes()
    },
    methods: {
      setIsAnatel () {
        let isUseAnatel = false
        const anatelCategories = this.anatelCategories
        this.buildCategories().forEach(function (category) {
          if (anatelCategories.includes(category.Name)) {
            isUseAnatel = true
          }
        })
        this.useAnatel = isUseAnatel
      },
      addTechnicalSpec () {
        let id = this.technicalAttributes.length + 1
        let newAttribute = {
          id: id,
          name: '',
          value: null
        }
        this.isAddDisabled = true
        this.technicalAttributes.push(newAttribute)
      },
      removeTechnicalSpec (id) {
        this.isAddDisabled = false
        this.technicalAttributes.forEach((technicalAttribute, index) => {
          if (technicalAttribute.id === id) {
            this.technicalAttributes.splice(index, 1)
          }
        })
      },
      formatToId (value) {
        return value
        .toUpperCase()
        .replace(/\s+/g, '_')
        .replace(/[^\w_]/g, '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
      },
      async fetchAttributes () {
        api.integracommerce.getAttributes()
          .then(attributes => {
            this.attributes = attributes
          })
          .catch(() => {
            //
          })
      },
      formatProduct () {
        return this.product.variations
          .filter(variation => variation.selected)
          .map(variation => {
            if (variation.attributes['color'] === undefined || variation.attributes['color'] === null) {
              variation.attributes['color'] = null
            }

            if (variation.attributes['size'] === undefined || variation.attributes['size'] === null) {
              variation.attributes['size'] = null
            }

            let formattedAttributes = []
            for (const key in this.product.attributes) {
              formattedAttributes.push({
                'id': key,
                'label': key,
                'valueId': this.product.attributes[key],
                'valueLabel': this.product.attributes[key]
              })
            }

            this.technicalAttributes.forEach((technicalAttribute, index) => {
              formattedAttributes.push({
                'id': this.formatToId(technicalAttribute.name),
                'label': technicalAttribute.name,
                'valueId': technicalAttribute.value,
                'valueLabel': technicalAttribute.value
              })
            })

            return {
              productId: this.product.productId,
              color: variation.attributes['color'],
              grid: this.getGrid(variation),
              attributes: formattedAttributes,
              gridType: this.getType(variation),
              categories: this.buildCategories(),
              sku: variation.sku,
              ncm: this.product.ncm || '',
              title: this.product.title,
              description: this.product.description,
              stock: variation.stock,
              price: variation.price,
              source: this.fromModule,
              ean: variation.ean,
              images: variation.images.length ? variation.images : null,
              width: variation.width,
              height: variation.height,
              weight: variation.weight,
              length: variation.length,
              brand: this.product.brand,
              warrantyTime: this.product.warrantyTime || 0,
              identifierAnatel: this.identifierAnatel,
              original: {
                product: this.product,
                variation: variation
              }
            }
          }
        )
      },
      buildCategories () {
        this.getCategoriesRecursive(this.product.categories)

        const categories = []
        for (let i in this.categories) {
          const category = this.categories[i]

          categories.push({
            Id: category.code.toString(),
            Name: category.name,
            ParentId: category.parentId.toString()
          })
        }

        return categories
      },
      isFormValid () {
        return this.technicalAttributes.every(attribute =>
          attribute.name && attribute.value
        )
      },
      getCategoriesRecursive (categories) {
        for (let i in categories) {
          const category = categories[i]

          let parentId = ''

          for (let i in this.categories) {
            const categoryTmp = this.categories[i]

            for (let j in categoryTmp.children) {
              const child = categoryTmp.children[j]

              if (child.code === category.code) {
                parentId = categoryTmp.code
              }
            }
          }

          category.parentId = parentId

          this.categories.push(category)

          if (category.children !== null) {
            this.getCategoriesRecursive(category.children)
          }
        }
      },
      getType (variation) {
        if (variation.attributes['flavor']) {
          return 'flavor'
        }

        if (variation.attributes['voltage']) {
          return 'voltage'
        }

        return 'size'
      },
      getGrid (variation) {
        if (variation.attributes['flavor']) {
          return variation.attributes['flavor']
        }

        if (variation.attributes['voltage']) {
          return variation.attributes['voltage']
        }

        if (variation.attributes['size']) {
          return variation.attributes['size']
        }

        return 'Único'
      },
      formatWarrantyToMonth (days) {
        if (days >= 30) {
          return Math.round(days / 30)
        }

        return
      }
    },
    computed: {
      ...mapGetters('errors', [
        'getError'
      ])
    },
    components: {
      SharedProductProvide,
      FormGroup
    }
  }
</script>

<style>
  .form-group {
    display: inline-block;
  }

  .no-padding {
    padding-left: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// Product.vue?05b2be77